import { componentProvider } from 'js-component-framework';
import ModalConversion from './modal-conversion';
import './modal-conversion.scss';

const modalConversionConfig = {
  name: 'conversion-modal',
  component: ModalConversion,
  querySelector: {
    content: '.embedded-conversion-content',
    close: '.modal-conversion__close',
  },
};

componentProvider(modalConversionConfig);
